import React from 'react'
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Button from "../CustomButtons/Button.jsx";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import LoaderComponent from "../Loader";
import { helper } from '../../../assets/js/utils/Element';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CustomInput from "../CustomInput/CustomInput";
import sendlinxIcon from "../../../assets/img/sendlinx-icon.png";
import newLinkModalStyle from "../../../assets/jss/user/newLinkModalStyle.jsx";
import Link from "@material-ui/core/Link";
import QRCode from 'qrcode.react';
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import ShareLinkModal from "./ShareLinkModal";
import { Link as RouterLink } from "react-router-dom";
import Api from "../../../assets/js/utils/Api";
import axios from "axios";
import DateTimePicker from "../CustomInput/DateTimePicker";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Check from "@material-ui/icons/Check";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const NewLinkModal = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        
        this.state = {
            snackbarOpen: false,
            title: "",
            linkPassword: this.props.linkPassword,
            expire: "",
            viewPassword: false,
            shareLinkModal: false,
            uploadFileModal: this.props.uploadFileModal,
            pdfTracking: false,
            requireVerification: false,
            recipients: [],
            emailTo: "",
            recipientError: false,
        };

        this.copyDownloadLink = this.copyDownloadLink.bind(this);
        this.closeSnackbar = this.closeSnackbar.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onEmailKeyUp = this.onEmailKeyUp.bind(this);
        this.onContinue = this.onContinue.bind(this);
    }
    copyDownloadLink(){
        let { downloadLink } = this.props;
        downloadLink = window.location.protocol+"//"+window.location.host+downloadLink;
        helper.copyTextToClipboard(downloadLink);
        this.setState({snackbarOpen: true});
    }
    closeSnackbar(){
        this.setState({snackbarOpen: false});
    }
    handleChange(e, name) {
        this.setState({
            [name]: e.target.value
        });
    }
    handleCheckbox(e, name){
        const newState = {
            [name]: e.target.checked
        };
        if(name === "requireVerification" && e.target.checked === false){
            newState.recipientError = false;
        }
        this.setState(newState);
    }
    downloadQRCode(){
        this.onShareLink('qrcode');

        const canvas = document.getElementById("qr-code");
        const pngUrl = canvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = "qr-code.png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }
    onViewPassword(){
        this.setState({
            viewPassword: !this.state.viewPassword
        })
    }
    onShareLinkModal(e){
        e.preventDefault();
        this.setState({
            uploadFileModal: false,
            shareLinkModal: true
        })
    }
    onShareLink(type = ''){
        const { linkHash } = this.props;
        const source = axios.CancelToken.source();

        let requestData = {
            hash: linkHash,
            type: type
        }
        Api.shareVia(requestData, source).then(data => {
            
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({
                    cancelToken: null,
                    errorMessage: err.message,
                    saving: false
                });
            }
        });
    }
    handleDateChange(date, name) {
        try{
            let parsedDate = new Date(date);
            if(parsedDate === "Invalid Date"){
                return;
            }
            this.setState({
                [name]: parsedDate.toISOString()
           });
        }catch(e){ console.log(e); }        
    }
    onClearDate(){
        this.setState({
            expire: ''
        })
    }
    // Collects valid recipient emails from the chips + whatever is currently
    // typed in the input. Returns { valid: [emails], invalid: "leftover text" }.
    collectRecipients(){
        const { emailTo } = this.state;
        let recipients = this.state.recipients.slice();
        if(emailTo && emailTo.length > 0){
            let commaSeparatedEmails = emailTo.split(/[;,]\s*/);
            commaSeparatedEmails.map((email) => {
                if(!recipients.includes(email.trim()) && emailRegex.test(email.trim())){
                    recipients.push(email.trim());
                }
                return null;
            });
            let invalidEmails = commaSeparatedEmails.filter(email => email.trim().length > 0 && !emailRegex.test(email.trim()));
            return { valid: recipients, invalid: invalidEmails.length > 0 ? invalidEmails.join(", ") : "" };
        }
        return { valid: recipients, invalid: "" };
    }
    onEmailKeyUp(event){
        if(event && event.nativeEvent.keyCode !== 13 && event.key !== "Tab"){
            return;
        }
        if(this.state.emailTo.length <= 0){
            return;
        }
        if(event && event.key === "Tab"){
            event.preventDefault();
        }
        const collected = this.collectRecipients();
        this.setState({
            recipients: collected.valid,
            emailTo: collected.invalid,
            recipientError: this.state.requireVerification && collected.valid.length <= 0
        });
    }
    removeRecipient(e, email){
        e.preventDefault();
        let recipients = this.state.recipients.slice();
        if(recipients.length <= 0 || email.length <= 0){
            return;
        }
        const index = recipients.indexOf(email);
        if(index !== -1){
            recipients.splice(index, 1);
        }
        this.setState({
            recipients: recipients,
            recipientError: this.state.requireVerification && recipients.length <= 0
        });
    }
    editRecipient(e, email){
        e.preventDefault();
        let recipients = this.state.recipients.slice();
        if(recipients.length <= 0 || email.length <= 0){
            return;
        }
        const index = recipients.indexOf(email);
        if(index !== -1){
            recipients.splice(index, 1);
        }
        this.setState({
            recipients: recipients,
            emailTo: email
        });
    }
    onContinue(){
        const { title, linkPassword, expire, pdfTracking, requireVerification } = this.state;
        const collected = this.collectRecipients();
        const recipients = collected.valid;
        if(requireVerification && recipients.length <= 0){
            this.setState({
                recipients: recipients,
                emailTo: collected.invalid,
                recipientError: true
            });
            return;
        }
        this.setState({
            recipients: recipients,
            emailTo: collected.invalid,
            recipientError: false
        });
        this.props.onLinkName(title, linkPassword, expire, pdfTracking, requireVerification, recipients);
    }
    renderDownloadButtons(){
        const { classes, downloadLink } = this.props;
        let downloadUrl = window.location.protocol+"//"+window.location.host+downloadLink
        
        return (
            <div className={classes.downloadLink}>
                <div className={classes.dNone}>
                    <QRCode value={downloadUrl} id='qr-code' />
                </div>
                <ul className='share-icon-lists'>
                    <li className='sendlinx-icon'>
                        <a href='/' onClick={(e) => this.onShareLinkModal(e)}>
                            <img src={sendlinxIcon} alt="sendlinx" />
                        </a>
                    </li>
                    <li>
                        <a onClick={() => this.onShareLink('email')} href={'mailto:?&subject=&cc=&bcc=&body='+downloadUrl} target="_blank" rel="noopener noreferrer">
                            <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="32.9111" cy="32.9111" r="32.9111" fill="#02B3B3"/>
                                <path d="M18.5181 20.2539C16.6836 20.2539 15.1953 21.6714 15.1953 23.4184C15.1953 24.4139 15.6868 25.3501 16.5244 25.9501L31.5876 36.7095C32.3767 37.2699 33.4566 37.2699 34.2458 36.7095L49.309 25.9501C50.1466 25.3501 50.6381 24.4139 50.6381 23.4184C50.6381 21.6714 49.1497 20.2539 47.3153 20.2539H18.5181ZM15.1953 27.6378V41.3508C15.1953 43.678 17.182 45.5702 19.6257 45.5702H46.2077C48.6513 45.5702 50.6381 43.678 50.6381 41.3508V27.6378L35.5749 38.3972C33.9966 39.5246 31.8368 39.5246 30.2585 38.3972L15.1953 27.6378Z" fill="white"/>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a onClick={() => this.onShareLink('facebook')} href={'https://www.facebook.com/sharer/sharer.php?u='+downloadUrl} target="_blank" rel="noopener noreferrer">
                            <svg width="67" height="66" viewBox="0 0 67 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="33.4512" cy="32.9111" r="32.9111" fill="#1877F2"/>
                                <path d="M27.9106 36.9598V50.6321H35.9646V36.9598H41.9703L43.2201 30.6733H35.9646V28.4492C35.9646 25.1259 37.374 23.8532 41.0122 23.8532C42.1439 23.8532 43.0534 23.8789 43.5811 23.9304V18.2288C42.5883 17.9781 40.1582 17.7209 38.7557 17.7209C31.3335 17.7209 27.9106 20.9671 27.9106 27.9671V30.6733H23.3281V36.9598H27.9106Z" fill="white"/>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a onClick={() => this.onShareLink('twitter')} href={'https://twitter.com/intent/tweet?url='+downloadUrl} target="_blank" rel="noopener noreferrer">
                            <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="32.9936" cy="32.9111" r="32.9111" fill="black"/>
                                <path d="M41.7266 20.2539H46.3871L36.2078 32.0491L48.1827 48.1018H38.8088L31.4615 38.3684L23.0645 48.1018H18.3973L29.283 35.4832L17.8032 20.2539H27.4148L34.0492 29.1505L41.7266 20.2539ZM40.0894 45.2768H42.6706L26.0087 22.9316H23.2361L40.0894 45.2768Z" fill="white"/>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a onClick={() => this.onShareLink('linkedin')} href={'https://www.linkedin.com/shareArticle?mini=true&url='+downloadUrl} target="_blank" rel="noopener noreferrer">
                            <svg width="67" height="66" viewBox="0 0 67 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="33.5483" cy="32.9111" r="32.9111" fill="#0D65C2"/>
                                <path d="M25.1594 48.1004H18.8597V27.8181H25.1594V48.1004ZM22.0062 25.0514C19.9922 25.0514 18.3579 23.3832 18.3579 21.3692C18.3579 20.4016 18.7423 19.4737 19.4265 18.7895C20.1106 18.1053 21.0386 17.7209 22.0062 17.7209C22.9737 17.7209 23.9017 18.1053 24.5859 18.7895C25.27 19.4737 25.6544 20.4016 25.6544 21.3692C25.6544 23.3832 24.0202 25.0514 22.0062 25.0514ZM48.7306 48.1004H42.4445V38.2271C42.4445 35.8741 42.397 32.8564 39.1692 32.8564C35.8939 32.8564 35.3921 35.4129 35.3921 38.0576V48.1004H29.0992V27.8181H35.1412V30.5848H35.2294C36.0702 28.9912 38.1249 27.3095 41.19 27.3095C47.5643 27.3095 48.7374 31.507 48.7374 36.959V48.1004H48.7306Z" fill="white"/>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <Link onClick={() => this.downloadQRCode()}>
                            <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="33.0884" cy="32.9111" r="32.9111" fill="#B3B3BF"/>
                                <path d="M17.8984 20.9759C17.8984 19.1789 19.3564 17.7209 21.1534 17.7209H27.6633C29.4603 17.7209 30.9182 19.1789 30.9182 20.9759V27.4858C30.9182 29.2828 29.4603 30.7407 27.6633 30.7407H21.1534C19.3564 30.7407 17.8984 29.2828 17.8984 27.4858V20.9759ZM22.2384 22.0609V26.4008H26.5783V22.0609H22.2384ZM17.8984 38.3356C17.8984 36.5386 19.3564 35.0807 21.1534 35.0807H27.6633C29.4603 35.0807 30.9182 36.5386 30.9182 38.3356V44.8455C30.9182 46.6425 29.4603 48.1004 27.6633 48.1004H21.1534C19.3564 48.1004 17.8984 46.6425 17.8984 44.8455V38.3356ZM22.2384 39.4206V43.7605H26.5783V39.4206H22.2384ZM38.5131 17.7209H45.023C46.82 17.7209 48.2779 19.1789 48.2779 20.9759V27.4858C48.2779 29.2828 46.82 30.7407 45.023 30.7407H38.5131C36.7161 30.7407 35.2582 29.2828 35.2582 27.4858V20.9759C35.2582 19.1789 36.7161 17.7209 38.5131 17.7209ZM43.938 22.0609H39.5981V26.4008H43.938V22.0609ZM35.2582 36.1656C35.2582 35.5689 35.7464 35.0807 36.3431 35.0807H40.6831C41.2798 35.0807 41.768 35.5689 41.768 36.1656C41.768 36.7624 42.2563 37.2506 42.853 37.2506H45.023C45.6197 37.2506 46.108 36.7624 46.108 36.1656C46.108 35.5689 46.5962 35.0807 47.193 35.0807C47.7897 35.0807 48.2779 35.5689 48.2779 36.1656V42.6755C48.2779 43.2723 47.7897 43.7605 47.193 43.7605H42.853C42.2563 43.7605 41.768 43.2723 41.768 42.6755C41.768 42.0788 41.2798 41.5906 40.6831 41.5906C40.0863 41.5906 39.5981 42.0788 39.5981 42.6755V47.0155C39.5981 47.6122 39.1098 48.1004 38.5131 48.1004H36.3431C35.7464 48.1004 35.2582 47.6122 35.2582 47.0155V36.1656ZM42.853 48.1004C42.5653 48.1004 42.2893 47.9861 42.0858 47.7827C41.8824 47.5792 41.768 47.3032 41.768 47.0155C41.768 46.7277 41.8824 46.4517 42.0858 46.2483C42.2893 46.0448 42.5653 45.9305 42.853 45.9305C43.1408 45.9305 43.4168 46.0448 43.6202 46.2483C43.8237 46.4517 43.938 46.7277 43.938 47.0155C43.938 47.3032 43.8237 47.5792 43.6202 47.7827C43.4168 47.9861 43.1408 48.1004 42.853 48.1004ZM47.193 48.1004C46.9052 48.1004 46.6292 47.9861 46.4258 47.7827C46.2223 47.5792 46.108 47.3032 46.108 47.0155C46.108 46.7277 46.2223 46.4517 46.4258 46.2483C46.6292 46.0448 46.9052 45.9305 47.193 45.9305C47.4807 45.9305 47.7567 46.0448 47.9602 46.2483C48.1636 46.4517 48.2779 46.7277 48.2779 47.0155C48.2779 47.3032 48.1636 47.5792 47.9602 47.7827C47.7567 47.9861 47.4807 48.1004 47.193 48.1004Z" fill="white"/>
                            </svg>
                        </Link>
                    </li>
                </ul>
                <p>Link Url</p>
                <div className='download-link-section'>
                    <div className='icon'>
                        <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 5.14464C0 2.30223 1.86458 0 4.16667 0H6.25C6.47917 0 6.66667 0.231509 6.66667 0.514464C6.66667 0.797419 6.47917 1.02893 6.25 1.02893H4.16667C2.32552 1.02893 0.833333 2.87135 0.833333 5.14464C0.833333 7.41793 2.32552 9.26035 4.16667 9.26035H6.25C6.47917 9.26035 6.66667 9.49186 6.66667 9.77482C6.66667 10.0578 6.47917 10.2893 6.25 10.2893H4.16667C1.86458 10.2893 0 7.98705 0 5.14464ZM15 5.14464C15 7.98705 13.1354 10.2893 10.8333 10.2893H8.75C8.52083 10.2893 8.33333 10.0578 8.33333 9.77482C8.33333 9.49186 8.52083 9.26035 8.75 9.26035H10.8333C12.6745 9.26035 14.1667 7.41793 14.1667 5.14464C14.1667 2.87135 12.6745 1.02893 10.8333 1.02893H8.75C8.52083 1.02893 8.33333 0.797419 8.33333 0.514464C8.33333 0.231509 8.52083 0 8.75 0H10.8333C13.1354 0 15 2.30223 15 5.14464ZM3.95833 4.63018H11.0417C11.2708 4.63018 11.4583 4.86168 11.4583 5.14464C11.4583 5.4276 11.2708 5.6591 11.0417 5.6591H3.95833C3.72917 5.6591 3.54167 5.4276 3.54167 5.14464C3.54167 4.86168 3.72917 4.63018 3.95833 4.63018Z" />
                        </svg>  
                    </div>
                    <p>{downloadUrl}</p>
                    <Button color="custom" size='sm' type="button" onClick={this.copyDownloadLink} >
                        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 11H7C6.44688 11 6 10.5531 6 10V2C6 1.44687 6.44688 1 7 1H10.3781C10.5094 1 10.6375 1.05313 10.7312 1.14688L12.8531 3.26875C12.9469 3.3625 13 3.49063 13 3.62188V10C13 10.5531 12.5531 11 12 11ZM13.5594 2.55938L11.4406 0.440625C11.1594 0.159375 10.7781 0 10.3813 0H7C5.89687 0 5 0.896875 5 2V10C5 11.1031 5.89687 12 7 12H12C13.1031 12 14 11.1031 14 10V3.62188C14 3.225 13.8406 2.84375 13.5594 2.5625V2.55938ZM2 4C0.896875 4 0 4.89687 0 6V14C0 15.1031 0.896875 16 2 16H7C8.10312 16 9 15.1031 9 14V13H8V14C8 14.5531 7.55312 15 7 15H2C1.44687 15 1 14.5531 1 14V6C1 5.44688 1.44687 5 2 5H4V4H2Z" fill="white"/>
                        </svg>
                        Copy
                    </Button>
                </div>
            </div>
        )
    }
    render() {
        const { classes, saving, loadingMessage, successMessage, errorMessage, downloadLink, linkName,
            totalFiles, havePdfFile } = this.props;
        const { title, linkPassword, viewPassword, shareLinkModal, uploadFileModal, expire, pdfTracking, requireVerification, recipients, emailTo, recipientError } = this.state;
        let downloadUrl = window.location.protocol+"//"+window.location.host+downloadLink
        const { user } = this.store.getState();
        
        if(uploadFileModal){
            return (
                <div className={classes.uploadFilesModal}>
                    <div className={classes.modalHeader}>
                        <Button
                            simple
                            className={classes.modalCloseButton+" "+classes.modalCloseButtonCustom}
                            key="close"
                            aria-label="Close"
                            onClick={() => this.props.onClose()}
                        >
                            {" "}
                            <CloseIcon className={classes.modalClose} />
                        </Button>
                        <div className="success-title-section">
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_1023_5761)">
                                    <path d="M14 28C17.713 28 21.274 26.525 23.8995 23.8995C26.525 21.274 28 17.713 28 14C28 10.287 26.525 6.72601 23.8995 4.10051C21.274 1.475 17.713 0 14 0C10.287 0 6.72601 1.475 4.10051 4.10051C1.475 6.72601 0 10.287 0 14C0 17.713 1.475 21.274 4.10051 23.8995C6.72601 26.525 10.287 28 14 28ZM20.1797 11.4297L13.1797 18.4297C12.6656 18.9438 11.8344 18.9438 11.3258 18.4297L7.82578 14.9297C7.31172 14.4156 7.31172 13.5844 7.82578 13.0758C8.33984 12.5672 9.17109 12.5617 9.67969 13.0758L12.25 15.6461L18.3203 9.57031C18.8344 9.05625 19.6656 9.05625 20.1742 9.57031C20.6828 10.0844 20.6883 10.9156 20.1742 11.4242L20.1797 11.4297Z" fill="#53E13C"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_1023_5761">
                                        <rect width="28" height="28" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <div className="success-title">
                                <h4 className={classes.modalTitle}>
                                    Success!
                                </h4>
                                <p>{totalFiles} of {totalFiles} uploades complete</p>
                            </div>
                        </div>
                    </div>
                    <div className={classes.uploaderComplete}>
                        {
                            downloadLink !== null ? 
                                <>
                                    <div className={classes.uploaderCompleteContent}>
                                        <h4 className={classes.modalTitle}>{successMessage}</h4> 
                                        <p className={classes.modalTitleDesc}>Share your file using the options below or copy the link to send manually.</p>
                                        { this.renderDownloadButtons() }
                                    </div>
                                    <div className={classes.uploadingSuccessFooter}>
                                        <Button color="white" className="transfer-button" type="button" onClick={() => this.props.sendAnother()} >Upload another</Button>
                                        <Button color="custom" className="transfer-button" type="button" onClick={() => this.props.onSuccess()} >Done</Button>
                                    </div>
                                </>
                            :
                                <></>
                        }
                    </div>
                </div>
            )
        }

        return (
            <Dialog
                classes={{
                    root: classes.modalRoot,
                    paper: classes.modal
                }}
                open={this.props.open}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="processingModal-modal-slide-title"
                aria-describedby="processingModal-modal-slide-description"
            >
                <DialogTitle
                    id="processingModal-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                >
                    {
                        linkName || saving === false ?
                            <Button
                                simple
                                className={classes.modalCloseButton+" "+classes.modalCloseButtonCustom}
                                key="close"
                                aria-label="Close"
                                onClick={() => this.props.onClose()}
                            >
                                {" "}
                                <CloseIcon className={classes.modalClose} />
                            </Button>
                        :
                            <></>
                    }
                    {
                        errorMessage !== null ?
                            <></>
                        :
                            saving ?
                                <>
                                    <h4 className={classes.modalTitle}>Generating Link</h4> 
                                    <p className={classes.modalTitleDesc}>{loadingMessage}</p>
                                </>
                            : linkName === false && saving === false ?
                                <>
                                    <h4 className={classes.modalTitle}>{successMessage}</h4> 
                                    {
                                        downloadLink !== null ?
                                            <p className={classes.modalTitleDesc}>Share your file using the options below or copy the link to send manually.</p>
                                        :
                                            <div className={classes.modalTitleMultiDesc}>
                                                <p className={classes.modalTitleDesc}>Please wait while we prepare your download link. It may take a few minutes depending on the size and number of files.</p>
                                                <p className={classes.modalTitleDesc}>You can check the status of this link in the Link Manager to know when it is ready to share. Once it is ready, you can copy the link and share it anywhere.</p>
                                            </div>
                                    }
                                </>
                            :
                                <>
                                    <h4 className={classes.modalTitle}>Create a Link</h4> 
                                    <p className={classes.modalTitleDesc}>Generate a shareable link to securely download selected files.</p>
                                </>
                    }
                </DialogTitle>
                <DialogContent
                    id="processingModal-modal-slide-description"
                    className={classes.modalBody+(linkName === false && saving === false ? ' success-body' : '')}
                >
                        {
                            linkName ?
                                <>
                                    <CustomInput
                                        labelText="Destination Link Name (optional)"
                                        id="input-linkTitle"
                                        value={title}
                                        inputProps={{
                                            name: "linkTitle",
                                            type: "text",
                                            onChange: (e) => this.handleChange(e, 'title'),
                                        }}
                                        formControlProps={{
                                            fullWidth: true,
                                            className: "custom-input m-zero"
                                        }}
                                    />
                                    <CustomInput
                                        labelText="Password (optional)"
                                        id="input-password"
                                        value={linkPassword}
                                        passwordInput={viewPassword ? false : true}
                                        inputProps={{
                                            name: "linkPassword",
                                            type: "text",
                                            onChange: (e) => this.handleChange(e, 'linkPassword'),
                                            autoComplete: 'off',
                                            endAdornment: (
                                                <InputAdornment 
                                                    className={classes.inputAdornment+' viewPasswordIcon'} 
                                                    onClick={() => this.onViewPassword() }
                                                    position='end'
                                                >
                                                    {
                                                        linkPassword ?
                                                            viewPassword ?
                                                                <VisibilityOffIcon className={classes.inputAdornmentIcon}/>
                                                            :
                                                                <VisibilityIcon className={classes.inputAdornmentIcon}/>
                                                        :
                                                            <></>
                                                    }
                                                </InputAdornment>
                                            ),
                                        }}
                                        formControlProps={{
                                            fullWidth: true,
                                            className: "custom-input"
                                        }}
                                    />
                                    <div className={classes.dateTimePicker+" datetime-element"}>
                                        <DateTimePicker
                                            labelText={"Expiry Date"}
                                            id="input-expire"
                                            value={expire}
                                            onChange={(date) => this.handleDateChange(date, 'expire')}
                                            formControlProps={{
                                                fullWidth: true,
                                                className: "custom-input"
                                            }}
                                            disablePast={true}
                                        />
                                        {
                                            expire && expire !== '' ?
                                                <Button className="clear-icon" justIcon color="custom" onClick={() => this.onClearDate()}>
                                                    <CloseIcon className={classes.inputAdornmentIcon}/>
                                                </Button>
                                            :
                                                <></>
                                        }
                                    </div>
                                    {
                                        havePdfFile && helper.isExtensionEnable(user, 'pdf_track') ?
                                            <div className={classes.pdfTrackingCheckbox}>
                                                <FormControlLabel
                                                    classes={{label: classes.label}}
                                                    control={
                                                        <Checkbox                                                
                                                            tabIndex={-1}
                                                            onClick={(e) => this.handleCheckbox(e, "pdfTracking")}
                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                            classes={{checked: classes.checked, root: classes.checkRoot}}
                                                            checked={(pdfTracking ? true : false)}
                                                        />
                                                    }
                                                    label="Enable PDF Analytics"
                                                />
                                            </div>
                                        :
                                            <></>
                                    }
                                    <div className={classes.pdfTrackingCheckbox}>
                                        <FormControlLabel
                                            classes={{label: classes.label}}
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    onClick={(e) => this.handleCheckbox(e, "requireVerification")}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{checked: classes.checked, root: classes.checkRoot}}
                                                    checked={(requireVerification ? true : false)}
                                                />
                                            }
                                            label="Require recipients to verify their email"
                                        />
                                    </div>
                                    {
                                        requireVerification ?
                                            <div className={classes.recipientEmails}>
                                                {
                                                    recipients.length > 0 ?
                                                        <div className={"react-tagsinput "+classes.tagsInput}>
                                                            <div className="users-lists">
                                                                {
                                                                    recipients.map((email, key) => {
                                                                        return (
                                                                            <span className="react-tagsinput-tag rose" key={key}>
                                                                                <span onClick={(e) => this.editRecipient(e, email)}>{email}</span>
                                                                                <a href="/" onClick={(e) => this.removeRecipient(e, email)}>&nbsp;</a>
                                                                            </span>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    :
                                                        <></>
                                                }
                                                <CustomInput
                                                    labelText="Recipient email(s)"
                                                    id="input-recipient-email"
                                                    error={recipientError || (emailTo.length > 0 && !emailRegex.test(emailTo))}
                                                    inputProps={{
                                                        name: "emailTo",
                                                        type: "email",
                                                        value: emailTo,
                                                        onChange: (e) => this.handleChange(e, 'emailTo'),
                                                        onKeyUp: (e) => this.onEmailKeyUp(e),
                                                        onKeyDown: (e) => this.onEmailKeyUp(e),
                                                        onBlur: () => this.onEmailKeyUp(null),
                                                        autoComplete: 'off',
                                                    }}
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        className: "custom-input m-zero"
                                                    }}
                                                />
                                                <p className={classes.recipientHint+(recipientError ? " "+classes.recipientErrorText : "")}>
                                                    {
                                                        recipientError ?
                                                            "Add at least one recipient email. Press Enter or Tab after each address."
                                                        :
                                                            "Only these emails can verify and access the files. Press Enter or Tab after each address."
                                                    }
                                                </p>
                                            </div>
                                        :
                                            <></>
                                    }
                                </>
                            : errorMessage !== null ?
                                <p className={classes.errorMessage}>{errorMessage}</p>
                            :
                                saving ?
                                    <LoaderComponent color="custom" align="center" />
                                :
                                    <>
                                        {
                                            downloadLink !== null ?
                                                this.renderDownloadButtons()
                                            :
                                                <></>
                                        }
                                    </>
                        }
                </DialogContent>
                <DialogActions className={classes.modalFooter}>
                    {
                        linkName ?
                            <Button color="custom" onClick={() => this.onContinue()}>
                                Continue
                            </Button>
                        : saving === false ?
                            <>
                                {
                                    downloadLink === null ?
                                        <RouterLink to={"/user/links"}>
                                            <Button color="border" onClick={() => this.props.onSuccess()}>
                                                GO TO LINK MANAGER
                                            </Button>
                                        </RouterLink>
                                    :
                                        <></>
                                }
                                <Button color="custom" onClick={() => this.props.onSuccess()}>
                                    Done
                                </Button>
                            </>
                        :
                            <></>
                    }
                </DialogActions>
                {
                    shareLinkModal ?
                        <ShareLinkModal
                            open={shareLinkModal}
                            store={this.store}
                            history={this.props.history}
                            linkPassword={linkPassword}
                            downloadLink={downloadUrl}
                            // Cancel returns to the link (URL, copy and share buttons) instead of closing everything.
                            onClose={() => this.setState({ shareLinkModal: false })}
                            onSuccess={() => this.props.onSuccess()}
                            linkHash={this.props.linkHash}
                            expire={expire || null}
                            requireVerification={requireVerification ? true : false}
                            initialRecipients={requireVerification ? recipients : []}
                            items={this.props.items}
                            path={this.props.path}
                        />
                    :
                    null
                }
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    className={classes.snackbar}
                    open={this.state.snackbarOpen}
                    autoHideDuration={1000}
                    onClose={this.closeSnackbar}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">Link Copied to Clipboard</span>}
                    action={[
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        className={classes.close}
                        onClick={this.closeSnackbar}
                    >
                        <CloseIcon />
                    </IconButton>,
                    ]}
                />
            </Dialog>
        )
    }
}

NewLinkModal.defaultProps = {
    items: [],
    path: "",
    history: null,
    open: false,
    loadingMessage: "",
    successMessage: "",
    saving: false,
    errorMessage: null,
    downloadUrl: null,
    linkName: false,
    onLinkName: function(){ },
    linkPassword: "",
    uploadFileModal: false,
    havePdfFile: false
}
NewLinkModal.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool,
    loadingMessage: PropTypes.string,
    saving: PropTypes.bool,
    errorMessage: PropTypes.string,
    downloadUrl: PropTypes.string,
    linkName: PropTypes.bool,
    onLinkName: PropTypes.func,
    uploadFileModal: PropTypes.bool,
    havePdfFile: PropTypes.bool
}
export default withStyles(newLinkModalStyle)(NewLinkModal);